import create from 'zustand'

import { Trueflags } from '../api/common/types'

export const useFeatureFlagsStore = create<{ flags: Trueflags; setFlags: (flags: Trueflags) => void }>((set) => ({
  flags: {} as Trueflags,
  setFlags: (flags: Trueflags) => set({ flags }),
}))
